module.exports = __webpack_public_path__ + "static/ebr-4-e47a89e5610e5225edbc293d3cd3caa6.jpg";